import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { UiTranslateModule } from '@fcom/ui-translate';
import {
  ButtonModule,
  FcomFormsModule,
  IconsModule,
  LoaderModule,
  ModalModule,
  UiComponentsModule,
} from '@fcom/ui-components';

import { CmsModule } from '../../cms/components';
import { ComponentsModule } from '../components';
import { PipesModule } from '../pipes';
import { MarketingPreferencesComponent } from './components';
import { ConsentService } from './services/consent.service';
import { DirectiveModule } from '../directives';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    ComponentsModule,
    CmsModule,
    FormsModule,
    FcomFormsModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    UiTranslateModule,
    UiComponentsModule,
    IconsModule,
    ModalModule,
    ButtonModule,
    DirectiveModule,
    LoaderModule,
  ],
  declarations: [MarketingPreferencesComponent],
  exports: [MarketingPreferencesComponent],
})
export class MarketingPreferencesModule {
  static forRoot(): ModuleWithProviders<MarketingPreferencesModule> {
    return {
      ngModule: MarketingPreferencesModule,
      providers: [ConsentService],
    };
  }
}
